import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'infans-care',
    templateUrl: './care.component.html',
    styleUrls: ['./care.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CareComponent {}
